import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-HubPageMap" */'@components/hubPage/MapImg'));
